import React, { useState } from "react";
import "./css/TermsReview.css"; // Add custom CSS for styling
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "./KICKS-6.png"; // Ensure this is the correct path to your logo

const API_URL =
  "https://lykns00a87.execute-api.us-east-2.amazonaws.com/default/football_app_data_crud";

const TermsReview = ({ userId }) => {
  const navigate = useNavigate();
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAcceptTerms = async () => {
    if (loading) return; // Prevent function execution if already loading

    setLoading(true);
    setErrorMessage("");

    const acceptedDate = new Date().toISOString();

    const payload = {
      operationType: "accepted_terms",
      data: {
        coach_id: userId,
        accepted_t_c: acceptedDate,
        accepted_policy: acceptedDate,
      },
    };

    try {
      console.log("Sending accepted_terms payload:", payload);
      const response = await axios.post(API_URL, payload);

      if (response.status === 200) {
        console.log("Successfully updated terms acceptance:", response.data);
        navigate("/", { state: { userId } });
      } else {
        console.error(
          "Failed to update terms acceptance:",
          response.statusText
        );
        setErrorMessage("Failed to update terms acceptance. Please try again.");
      }
    } catch (error) {
      console.error("Error in handleAcceptTerms:", error.message);
      setErrorMessage("An error occurred. Please try again.");
    } finally {
      // Ensure loading is turned off only after navigating or handling error
      setLoading(false);
    }
  };

  return (
    <div className="terms-review-container">
      <div className="logo-container">
        <img src={logo} alt="KICKS Logo" className="logo" />
      </div>
      <h2 className="title">Review and Accept Terms</h2>

      {errorMessage && <p className="error-message">{errorMessage}</p>}

      <div
        className="terms-checkbox"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "20px",
        }}
      >
        <input
          type="checkbox"
          id="termsCheckbox"
          style={{ width: "16px", height: "16px" }}
          checked={hasAcceptedTerms}
          onChange={(e) => setHasAcceptedTerms(e.target.checked)}
        />
        <label
          htmlFor="termsCheckbox"
          style={{ fontSize: "0.9rem", lineHeight: "1.2", color: "#444" }}
        >
          I have reviewed and agree to the{" "}
          <a
            href="https://www.thekicksapp.com/terms.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            Terms and Conditions
          </a>{" "}
          and{" "}
          <a
            href="https://www.thekicksapp.com/policy.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            Privacy Policy
          </a>
          .
        </label>
      </div>

      <button
        onClick={handleAcceptTerms}
        className="terms-review-button"
        disabled={!hasAcceptedTerms || loading} // Disable if not accepted or loading
      >
        {loading ? "Submitting..." : "Continue"}
      </button>
    </div>
  );
};

export default TermsReview;
